import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorPage } from "@/pages/ErrorPage";

interface ErrorBoundaryState {
  error: Error | null;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Sentry wire-up lands in the TZ that turns monitoring on.
    if (import.meta.env.DEV) {
      console.error("ErrorBoundary caught", error, info);
    }
  }

  private readonly reset = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    if (this.state.error) {
      return <ErrorPage error={this.state.error} resetError={this.reset} />;
    }
    return this.props.children;
  }
}
